import React from 'react';
import { InView } from 'react-intersection-observer';
import { HtmlContent } from '../common';
import { getSectionId } from '../../utils/helpers';
import './LegalPageSection.scss';

const LegalPageSection = ({
  index,
  section,
  sectionInViewHandler,
}) => {
  const {
    sectionHeading,
    content,
  } = section;
  const sectionId = getSectionId(index, sectionHeading.text);
  return (
    <InView
      id={sectionId}
      className="legal-page-section"
      rootMargin="-100px 0px 0px"
      as="div"
      onChange={inView => sectionInViewHandler(index, inView)}
    >
      <h2 className="section-title">
        {sectionHeading.text}
      </h2>
      <HtmlContent
        className="section-content"
        content={content.html}
      />
    </InView>
  );
};

export default LegalPageSection;
